module.exports = __webpack_public_path__ + "img/yingyong24.cb375bbd.webp";